import { isEqual } from 'lodash'
import type { Sections } from '../types'

export const isChangeInOnboardingData = (
  onboardingData: any,
  getOnboardingStateData: Sections
) => {
  const { lockMetadata: metaData, ...restOnboardingData } = onboardingData
  const { lockMetadata, ...restGetOnboardingStateData } = getOnboardingStateData
  return !isEqual(restOnboardingData, restGetOnboardingStateData)
}
